import React from 'react'

import { makeStyles, useTheme } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { graphql, useStaticQuery, Link } from 'gatsby'
import slugify from 'slugify'
import profilepic from '../assets/images/profilepic_50x50.jpg'

const query = graphql`
	{
		allContentfulBlogPost(
			filter: { featured: { eq: true } }
			sort: { fields: createdAt, order: DESC }
			limit: 2
		) {
			nodes {
				shortTitle
				id
				title
				tags {
					tags
				}
				body {
					body
				}
			}
		}
	}
`

const useStyles = makeStyles((theme) => ({
	mainCard: {
		borderRadius: 0,
		width: '47.5em',
		height: '15.625em',
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			marginTop: '-1em',
		},
		[theme.breakpoints.down('xs')]: {
			width: '100%',
			marginTop: '3em',
		},
	},
	altCard: {
		borderRadius: 0,
		width: '22.5em',
		height: '9.375em',
		marginTop: '2.5em',
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
	},
	altContent: {
		height: '100%',
		padding: '1.875em',
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
	},
}))

export default function LandingPage({ title, description, author }) {
	const {
		allContentfulBlogPost: { nodes: featuredPosts },
	} = useStaticQuery(query)
	const classes = useStyles()
	const theme = useTheme()
	const matchesSM = useMediaQuery(theme.breakpoints.down('sm'))
	const matchesXS = useMediaQuery(theme.breakpoints.down('xs'))

	return (
		<>
			<Grid item lg={12}>
				<Grid item container justify='center'>
					<Paper className={classes.mainCard}>
						<Grid
							container
							style={{
								height: '100%',
								paddingLeft: matchesXS
									? '.75em'
									: matchesSM
									? '3em'
									: '1.875em',
								paddingRight: matchesXS
									? '.75em'
									: matchesSM
									? '3em'
									: '1.875em',
							}}
						>
							<Grid container justify={matchesSM ? 'center' : undefined}>
								<Grid item style={{ paddingTop: '3.6875em' }}>
									<Typography
										variant='h4'
										style={{
											fontSize: matchesXS ? '1.5rem' : '2.5rem',
											color: theme.palette.common.accent,
										}}
									>
										Welcome to {title}
									</Typography>
								</Grid>
							</Grid>
							<Grid container>
								<Grid item>
									<Typography
										variant='h5'
										align={matchesSM ? 'center' : undefined}
										style={{
											color: theme.palette.common.light,
											marginTop: '-1em',
											fontSize: matchesXS
												? '1.25rem'
												: matchesSM
												? '1.25rem'
												: undefined,
											paddingLeft: matchesXS
												? undefined
												: matchesSM
												? 20
												: undefined,
										}}
									>
										{description}
									</Typography>
								</Grid>
							</Grid>
						</Grid>
					</Paper>
				</Grid>
			</Grid>
			<Grid item>
				<Grid
					container
					spacing={matchesSM ? 0 : 4}
					justify={matchesSM ? 'center' : undefined}
					style={{ paddingBottom: matchesXS ? '2em' : undefined }}
				>
					{featuredPosts.map((post) => {
						const slug = slugify(post.title, { lower: true })
						return (
							<Grid item xs={12} md={6} key={post.id}>
								<Paper
									className={classes.altCard}
									style={{
										marginLeft: matchesSM ? 'auto' : undefined,
										marginRight: matchesSM ? 'auto' : undefined,
									}}
								>
									<Grid container className={classes.altContent}>
										<Grid container>
											<Grid item md={10}>
												<Link
													to={`/articles/${slug}`}
													style={{ textDecoration: 'none' }}
												>
													<Typography
														variant='h6'
														style={{
															color: theme.palette.common.accent,
															textTransform: 'uppercase',
															fontSize: '1rem',
														}}
													>
														{post.shortTitle}
													</Typography>
												</Link>
											</Grid>
										</Grid>
										<Grid container alignItems='flex-end'>
											<Grid item xs={10} sm={11}>
												<Typography
													variant='h6'
													style={{
														color: theme.palette.common.light,
														fontSize: '1rem',
													}}
												>
													By {author}{' '}
													<span style={{ color: '#d9d9d9', fontSize: '.9rem' }}>
														-{' '}
														{Math.round(post.body.body.split(' ').length / 200)}{' '}
														min read
													</span>
												</Typography>
											</Grid>
											<Grid item xs={2} sm={1}>
												<Avatar
													style={{
														height: 24,
														width: 24,
														backgroundColor: theme.palette.common.darker,
														color: theme.palette.common.light,
													}}
													src={profilepic}
													alt='authors profile pic'
												/>
											</Grid>
										</Grid>
									</Grid>
								</Paper>
							</Grid>
						)
					})}
				</Grid>
			</Grid>
		</>
	)
}
